
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/category",
      function () {
        return require("private-next-pages/gifts/category.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/category"])
      });
    }
  